import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

import { NavigationService } from 'src/app/services/navigation/navigation.service';

@Component({
  selector: 'app-furniture',
  templateUrl: './furniture.component.html',
  styleUrls: ['./furniture.component.scss'],
})
export class FurnitureComponent implements OnInit, OnDestroy {
  requiresNavbar = false;
  backTitle = '';
  backNavigation = '';

  private subscriptions: Array<Subscription> = [];

  constructor(
    private router: Router,
    private navService: NavigationService,
    public config: NgbModalConfig
  ) {
    this.router.events.subscribe((_) => {
      const url = router.url.toString();

      // Disables navigation when on starting page.
      this.requiresNavbar = url.includes('employer');
    });

    // Set global config for backdrop of modal so it doesn't close on a click event.
    config.backdrop = 'static';
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.navService.backNavTitle.subscribe((data: string) => {
        this.backTitle = data;
      })
    );

    this.subscriptions.push(
      this.navService.backNavUrl.subscribe((data: string) => {
        this.backNavigation = data;
      })
    );
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }
}
